import { useMemo } from 'react';
import { Alert } from './styledComponent';

export const PartSpecificMessages = ({
  quotedPartNumbers,
  partNumbersToMessage,
  severity = 'warning',
}: {
  quotedPartNumbers: string[];
  partNumbersToMessage: Record<string, string>;
  severity?: 'error' | 'warning' | 'info' | 'success';
}) => {
  const uniqueMessages = useMemo(() => {
    const messages = quotedPartNumbers
      .filter((partNumber) => partNumbersToMessage[partNumber])
      .map((partNumber) => partNumbersToMessage[partNumber]);

    return Array.from(new Set(messages));
  }, [quotedPartNumbers, partNumbersToMessage]);

  return uniqueMessages.map((message, index) => (
    <Alert severity={severity} key={index}>
      {message}
    </Alert>
  ));
};
